module.exports = __webpack_public_path__ + "img/pocket-5_jp.7b34c6c.jpg";